/** Original roster — inspired by arena brawlers, not third-party IP. */
export const FIGHTERS = [
    {
        id: 0,
        slug: "volt-slinger",
        name: "Volt Slinger",
        role: "skirmisher",
        tagline: "Clean arcs, cruel timing.",
        maxHp: 2800,
        moveSpeed: 210,
        primaryDamage: 520,
        projectileSpeed: 480,
        fireCooldownMs: 380,
        ammoMax: 3,
        reloadMs: 1400,
        spreadShots: 1,
        spreadAngleDeg: 0,
        superDamage: 800,
        superProjectileSpeed: 420,
        superRadius: 0,
        tint: 0x7cfbff,
    },
    {
        id: 1,
        slug: "arc-radial",
        name: "Arc Radial",
        role: "artillery",
        tagline: "Wide bands, narrow escapes.",
        maxHp: 2400,
        moveSpeed: 185,
        primaryDamage: 380,
        projectileSpeed: 520,
        fireCooldownMs: 520,
        ammoMax: 3,
        reloadMs: 1600,
        spreadShots: 3,
        spreadAngleDeg: 14,
        superDamage: 420,
        superProjectileSpeed: 380,
        superRadius: 72,
        tint: 0xff7ad9,
    },
    {
        id: 2,
        slug: "hex-bunker",
        name: "Hex Bunker",
        role: "tank",
        tagline: "Frontline geometry.",
        maxHp: 4000,
        moveSpeed: 165,
        primaryDamage: 480,
        projectileSpeed: 400,
        fireCooldownMs: 550,
        ammoMax: 2,
        reloadMs: 1800,
        spreadShots: 5,
        spreadAngleDeg: 10,
        superDamage: 300,
        superProjectileSpeed: 320,
        superRadius: 88,
        tint: 0xb8ff6b,
    },
];
export function getFighter(id) {
    return FIGHTERS.find((f) => f.id === id) ?? FIGHTERS[0];
}
//# sourceMappingURL=brawlers.js.map